export default "__VITE_ASSET__oRo8w$3j__"